// extracted by mini-css-extract-plugin
export default {"loading-screen":"LoadingScreen_loading-screen__2u3kg","logo-letter":"LoadingScreen_logo-letter__Qb5Ma","fadeIn":"LoadingScreen_fadeIn__QANxi"};